import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { UniteMesureDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-unites-mesure-select',
  templateUrl: './unites-mesure-select.component.html',
  styleUrls: ['./unites-mesure-select.component.css']
})
export class UnitesMesureSelectComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.unitesMesure$) unitesMesure$: Observable<UniteMesureDto[]>;

  @Input() width: number;

  @Input() uniteMesureId: number;
  @Input() readOnly: boolean = false;
  @Output() uniteMesureIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  UnitesMesure: UniteMesureDto[] = [];

  um: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
    }

  ngOnInit() {
    if(this.uniteMesureId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.uniteMesureId));
    }
    this.um = this.unitesMesure$.subscribe(res => {
      if (res != null) {
        this.UnitesMesure = res;
      }
    });
  }

  ngOnDestroy() {
    this.um?.unsubscribe();
  }

  updateInfo(event) {
    if (!!this.cell && this.InitId != this.uniteMesureId) {
      this.cell.setValue(this.uniteMesureId);
    }
    //this.uniteMesureId = event.selectedItem != null ? event.selectedItem.Id : this.uniteMesureId;
    this.uniteMesureIdChange.emit(this.uniteMesureId);
  }

}
